;(function() {
"use strict";

/*
 * This fixes a problem with dynamodb roundtripping numbers to strings.
 * Fix is from the angular docs: https://docs.angularjs.org/error/ngModel/numfmt
 */

angular.module('tmr').directive('stringToNumber', function() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function(value) {
        return '' + value;
      });
      ngModel.$formatters.push(function(value) {
        return parseFloat(value);
      });
    }
  };
});
}());
